import { DashboardRoutes } from "@/router";
import { PluginTypeEnum, ServiceTypeEnum } from "@payping/api";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";

export enum ServiceUITypeEnum {
  trust = 0,
  donateAddon = 1,
  githubDonate = 2,
  donateScript = 3,
  messaging = 4,
  plugins = 5,
  links = 6,
}

export const pluginsTagsList = {
  wooCommerce: "wooCommerce",
  eCommerce: "eCommerce",
  wordpress: "wordpress",
  payPingFinancialItem: "payPingFinancialItem",
  nopCommerce: "nopCommerce",
  postMessage: "postMessage",
  learnPress: "learnPress",
  sellingTrainingCourses: "sellingTrainingCourses",
  theme: "theme",
  advertisement: "advertisement",
  VIPMemberShip: "VIPMemberShip",
  sellingContent: "sellingContent",
  VIP: "VIP",
  usersRating: "usersRating",
  userPrivilege: "userPrivilege",
  wallet: "wallet",
  edd: "edd",
  contactForm7: "contactForm7",
  openCart: "openCart",
  joomla: "joomla",
  j2Store: "j2Store",
  prestaShop: "prestaShop",
  donate: "donate",
  salesManagement: "salesManagement",
  customerManagement: "customerManagement",
  formMaker: "formMaker",
  gravityForms: "gravityForms",
  paymentForm: "paymentForm",
  codeStoreScript: "codeStoreScript",
  chargeCardSales: "chargeCardSales",
} as const;

export type PluginItemType<T = PluginTypeEnum | ServiceTypeEnum | ServiceUITypeEnum> = {
  helpLink?: string;
  logo: string;
  translationKey: string;
  pathName?: string;
  subTitle?: boolean;
  downloadLink?:
    | string
    | {
        translationKey: string;
        helpLink?: string;
        downloadLink?: string;
      }[];

  tags?: (typeof pluginsTagsList)[keyof typeof pluginsTagsList][];
  serviceType: T;
  googleTrackId?: string;

  receiveTokenGoogleTrackId?: string;
  downloadLinkGoogleTrackId?: string;
  helpLinkGoogleTrackId?: string;
};

type ServicesAsPluginListKeys = "telegram" | "kavehNegar" | "mailerLite";
export const servicesAsPluginList: Record<ServicesAsPluginListKeys, PluginItemType<ServiceTypeEnum>> = {
  telegram: {
    helpLink: buildUrl(URLS.PPNG_URL, "/t/7D6p").toString(),
    logo: `${URLS.STORAGE_URL}/services-logo/new/Telegram.png`,
    translationKey: "telegram",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "telegram"),
    serviceType: ServiceTypeEnum.Telegram,
    googleTrackId: "telegramconnect",
  },
  kavehNegar: {
    helpLink: buildUrl(URLS.PPNG_URL, "/t/ajVC").toString(),
    logo: `${URLS.STORAGE_URL}/services-logo/new/KavehNegar.png`,
    translationKey: "kavehNegar",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "kavehNegar"),
    serviceType: ServiceTypeEnum.KavehNegar,
    googleTrackId: "kavenegarconnect",
  },
  mailerLite: {
    helpLink: buildUrl(URLS.PPNG_URL, "/t/1lwX").toString(),
    logo: `${URLS.STORAGE_URL}/services-logo/new/MailerLite.png`,
    translationKey: "mailerLite",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "mailerLite"),
    subTitle: true,
    serviceType: ServiceTypeEnum.MailerLite,
    googleTrackId: "mailerlite",
  },
};

type UiServiceAsPluginListKeys = "donateScript" | "githubDonate" | "namadPayping";
export const uiServiceAsPluginList: Record<UiServiceAsPluginListKeys, PluginItemType<ServiceUITypeEnum>> = {
  donateScript: {
    helpLink: buildUrl(URLS.PPNG_URL, "/t/l6vf").toString(),
    logo: `${URLS.STORAGE_URL}/services-logo/new/PaypingDonate.png`,
    translationKey: "donateScript",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "donateScript"),
    subTitle: true,
    serviceType: ServiceUITypeEnum.donateScript,
    googleTrackId: "donatescript",
  },
  githubDonate: {
    logo: `${URLS.STORAGE_URL}/services-logo/new/GithubDonate.png`,
    translationKey: "githubDonate",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "githubDonate"),
    subTitle: true,
    serviceType: ServiceUITypeEnum.githubDonate,
    googleTrackId: "githubdonate",
  },
  namadPayping: {
    logo: `${URLS.STORAGE_URL}/services-logo/new/PaypingTrust.png`,
    translationKey: "namadPayping",
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "namadPayping"),
    serviceType: ServiceUITypeEnum.trust,
    googleTrackId: "enamad",
  },
};

export const featuredPluginsList = {
  ...uiServiceAsPluginList,
  ...servicesAsPluginList,
};

export const pluginsListList: { [key: string]: PluginItemType<PluginTypeEnum> } = {
  wpWooCommerce: {
    // data-google-track
    receiveTokenGoogleTrackId: "woo-token",
    downloadLinkGoogleTrackId: "woo-download",
    helpLinkGoogleTrackId: "woo-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-woocommerce").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-woocommerce").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/woocommerce.png`,
    translationKey: "wpWooCommerce",
    tags: ["wooCommerce", "eCommerce", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpWooCommerce"),
    serviceType: PluginTypeEnum.Woocommerce,
  },
  wpBnpl: {
    receiveTokenGoogleTrackId: "bnpl-wordpress-plugin-token",
    downloadLinkGoogleTrackId: "bnpl-wordpress-plugin-download",
    helpLink: undefined,

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-installment-payment-wordpress-plugin").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/bnpl-wordpress.jpg`,
    translationKey: "wpBnpl",
    tags: ["wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "bnplWordpress"),
    serviceType: PluginTypeEnum.WpBnpl,
  },
  nopCommerce: {
    // data-google-track
    receiveTokenGoogleTrackId: "nopcommerce-token",
    downloadLinkGoogleTrackId: "nopcommerce-download",
    helpLinkGoogleTrackId: "nopcommerce-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-nopcommerce").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-nopcommerce").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/nop-commerce.png`,
    translationKey: "nopCommerce",
    tags: ["nopCommerce", "eCommerce"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "nopCommerce"),
    serviceType: PluginTypeEnum.NopCommerce,
  },
  wpUserFrontend: {
    // data-google-track
    receiveTokenGoogleTrackId: "userfrontend-token",
    downloadLinkGoogleTrackId: "userfrontend-download",
    helpLinkGoogleTrackId: "userfrontend-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-userfrontend").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-userfrontend").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/wp-user-frontend.png`,
    translationKey: "wpUserFrontend",
    tags: ["wordpress", "postMessage"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpUserFrontend"),
    serviceType: PluginTypeEnum.WpUserFrontend,
  },
  wpLearnPress: {
    // data-google-track
    receiveTokenGoogleTrackId: "learnpress-token",
    downloadLinkGoogleTrackId: "learnpress-download",
    helpLinkGoogleTrackId: "learnpress-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-learnpress").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-learnpress").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/learnpress.png`,
    translationKey: "wpLearnPress",
    tags: ["learnPress", "sellingTrainingCourses", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpLearnPress"),
    serviceType: PluginTypeEnum.LearnPress,
  },
  wpClassiPress: {
    // data-google-track
    receiveTokenGoogleTrackId: "classipresstheme-token",
    downloadLinkGoogleTrackId: "classipresstheme-download",
    helpLinkGoogleTrackId: "classipresstheme-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-classipresstheme").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-classipresstheme").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/classipress.png`,
    translationKey: "wpClassiPress",
    tags: ["wordpress", "theme", "advertisement"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpClassiPress"),
    serviceType: PluginTypeEnum.ClassiPress,
  },

  wpRestrictContentPro: {
    // data-google-track
    receiveTokenGoogleTrackId: "restrictcontentpro-token",
    downloadLinkGoogleTrackId: "restrictcontentpro-download",
    helpLinkGoogleTrackId: "restrictcontentpro-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-restrictcontentpro").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-restrictcontentpro").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/restrict_content_pro.png`,
    translationKey: "wpRestrictContentPro",
    tags: ["VIPMemberShip", "sellingContent", "wordpress", "VIP"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpRestrictContentPro"),
    serviceType: PluginTypeEnum.RestrictContentPro,
  },
  wpMyCred: {
    // data-google-track
    receiveTokenGoogleTrackId: "mycred-token",
    downloadLinkGoogleTrackId: "mycred-download",
    helpLinkGoogleTrackId: "mycred-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-mycred").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-mycred").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/mycred.png`,
    translationKey: "wpMyCred",
    tags: ["wordpress", "usersRating", "userPrivilege", "wallet", "wooCommerce", "edd"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpMyCred"),
    serviceType: PluginTypeEnum.MyCred,
  },
  wpContactForm7: {
    // data-google-track
    receiveTokenGoogleTrackId: "contentform7-token",
    downloadLinkGoogleTrackId: "contentform7-download",
    helpLinkGoogleTrackId: "contentform7-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-contentform7").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-contentform7").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/contact_form7.png`,
    translationKey: "wpContactForm7",
    tags: ["contactForm7", "formMaker", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpContactForm7"),
    serviceType: PluginTypeEnum.ContactForm7,
  },
  openCart: {
    // data-google-track
    receiveTokenGoogleTrackId: "opencart-token",
    downloadLinkGoogleTrackId: "opencart-download",
    helpLinkGoogleTrackId: "opencart-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-opencart").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-opencart").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/opencart.png`,
    translationKey: "openCart",
    tags: ["openCart", "eCommerce"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "openCart"),
    serviceType: PluginTypeEnum.Opencart,
  },
  j2Store: {
    // data-google-track
    receiveTokenGoogleTrackId: "j2store-token",
    downloadLinkGoogleTrackId: "j2store-download",
    helpLinkGoogleTrackId: "j2store-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-j2store").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-j2store").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/j2store.png`,
    translationKey: "j2Store",
    tags: ["eCommerce", "joomla", "j2Store"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpWooCommerce"),
    serviceType: PluginTypeEnum.J2Store,
  },
  prestaShop: {
    // data-google-track
    receiveTokenGoogleTrackId: "prestashop-token",
    downloadLinkGoogleTrackId: "prestashop-download",
    helpLinkGoogleTrackId: "prestashop-help",

    downloadLink: [
      {
        translationKey: "prestaShop.v1.6",
        downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-prestaShop-v1-6").toString(),
      },
      {
        translationKey: "prestaShop.v1.7",
        downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-prestaShop-v1-7").toString(),
      },
    ],
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-prestaShop").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/prestashop.png`,
    translationKey: "prestaShop",
    tags: ["prestaShop", "eCommerce"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "prestaShop"),
    serviceType: PluginTypeEnum.PrestaShop,
  },
  wpGive: {
    // data-google-track
    receiveTokenGoogleTrackId: "givewp-token",
    downloadLinkGoogleTrackId: "givewp-download",
    helpLinkGoogleTrackId: "givewp-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-givewp").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-givewp").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/give.png`,
    translationKey: "wpGive",
    tags: ["donate", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpGive"),
    serviceType: PluginTypeEnum.Give,
  },
  wpPaidMembershipPro: {
    // data-google-track
    receiveTokenGoogleTrackId: "paidmembershippro-token",
    downloadLinkGoogleTrackId: "paidmembershippro-download",
    helpLinkGoogleTrackId: "paidmembershippro-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-paidmembershippro").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-paidmembershippro").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/paidpro.png`,
    translationKey: "wpPaidMembershipPro",
    tags: ["wordpress", "VIPMemberShip", "VIP"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpPaidMembershipPro"),
    serviceType: PluginTypeEnum.PaidMembershipsPro,
  },
  WHMCS: {
    // data-google-track
    receiveTokenGoogleTrackId: "whmcs-token",
    downloadLinkGoogleTrackId: "whmcs-download",
    helpLinkGoogleTrackId: "whmcs-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-whmcs").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-whmcs").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/whmcs.png`,
    translationKey: "WHMCS",
    tags: ["salesManagement", "customerManagement", "eCommerce"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "WHMCS"),
    serviceType: PluginTypeEnum.Whmcs,
  },
  wpGravityForms: {
    // data-google-track
    receiveTokenGoogleTrackId: "gravityforms-token",
    downloadLinkGoogleTrackId: "gravityforms-download",
    helpLinkGoogleTrackId: "gravityforms-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-gravityforms").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-gravityforms").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/gravity.png`,
    translationKey: "wpGravityForms",
    tags: ["formMaker", "gravityForms", "paymentForm", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpGravityForms"),
    serviceType: PluginTypeEnum.GravityForms,
  },
  wpEasyDigitalDownloads: {
    // data-google-track
    receiveTokenGoogleTrackId: "edd-token",
    downloadLinkGoogleTrackId: "edd-download",
    helpLinkGoogleTrackId: "edd-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-edd").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-edd").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/easy.png`,
    translationKey: "wpEasyDigitalDownloads",
    tags: ["eCommerce", "edd", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpEasyDigitalDownloads"),
    serviceType: PluginTypeEnum.Edd,
  },
  wpDonatePayping: {
    // data-google-track
    receiveTokenGoogleTrackId: "wpdonate-token",
    downloadLinkGoogleTrackId: "wpdonate-download",
    helpLinkGoogleTrackId: "wpdonate-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-donate").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-donate").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/wp.png`,
    translationKey: "wpDonatePayping",
    tags: ["donate", "paymentForm", "wordpress"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "wpDonatePayping"),
    serviceType: PluginTypeEnum.Donate,
  },

  virtualFreer: {
    // data-google-track
    receiveTokenGoogleTrackId: "virtualfreer-token",
    downloadLinkGoogleTrackId: "virtualfreer-download",
    helpLinkGoogleTrackId: "virtualfreer-help",

    downloadLink: buildUrl(URLS.PPNG_URL, "/t/download-plugin-virtualfreer").toString(),
    helpLink: buildUrl(URLS.PPNG_URL, "/t/help-plugin-virtualfreer").toString(),
    logo: `${URLS.STORAGE_URL}/landing/plugin/logo/virtual.png`,
    translationKey: "virtualFreer",
    tags: ["codeStoreScript", "chargeCardSales"],
    pathName: DashboardRoutes.connections.plugins.details.url.replace(":name", "virtualFreer"),
    serviceType: PluginTypeEnum.VirtualFreer,
  },
};
